const AG_GRID_LOCALE_HE = {
  // Filter
  applyFilter: "החל",
  resetFilter: "אתחל",
  clearFilter: "נקה",
  cancelFilter: "בטל",
  filterOoo: "פילטר...",
  contains: "מכיל",
  greaterThanOrEqual: "גדול מ-",
  lessThanOrEqual: "קטן מ-",
  inRange: "טווח",
  inRangeStart: "גדול מ...",
  inRangeEnd: "קטן מ..."
};

export default AG_GRID_LOCALE_HE;
